<template>
    <page-container class="grid grid-cols-12 gap-8">
        <settings-sidebar></settings-sidebar>
        <div ref="content" class="col-span-12 md:col-span-8 lg:col-span-10">
            <page-loading v-if="!group"></page-loading>
            <template v-else>
                <group-billing-details
                    v-show="hash === 'billing-details' || !hash"
                    :group="group"
                    :isAdminOrOwner="isAdminOrOwner"
                />

                <group-proforma-invoices
                    v-if="group.is_billable && typeof group.payment_terms_days === 'number'"
                    v-show="hash === 'proforma-invoices'"
                    :team-id="props.teamId"
                    :group-id="group.group_id"
                    :payment-terms-days="group.payment_terms_days"
                />

                <group-historical-invoices
                    v-show="hash === 'historical-invoices'"
                    :team-id="props.teamId"
                    :group-id="group.group_id"
                />
            </template>
        </div>
    </page-container>
</template>

<script setup>
import GroupBillingDetails from '~/components/settings/teams/groups/billing/GroupBillingDetails.vue';
import GroupProformaInvoices from './GroupProformaInvoices.vue';
import GroupHistoricalInvoices from './GroupHistoricalInvoices.vue';
import PageContainer from '~/components/general/PageContainer.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import SettingsSidebar from '../menus/SettingsSidebar.vue';
import { ref, onMounted } from 'vue';
import { groupsClient } from '~/services';
import { useSettingsHash } from '~/composables/useSettingsHash';

const { hash, content } = useSettingsHash();

const group = ref(null);

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    groupId: {
        type: String,
        required: true,
    },
});

const isAdminOrOwner = Spark.isAdminOrOwner || Spark.roleOnCurrentGroup === 'admin';

onMounted(async () => {
    try {
        const response = await groupsClient.getGroup({ teamId: props.teamId }, props.groupId);
        group.value = response.data;
    } catch (error) {
        console.error('Failed to fetch group:', error);
    }
});
</script>
